<pr-form (onSubmit)="submit()" [title]="'Foyer fiscal'" [formGroup]="form">
  <input formControlName="id" type="hidden" />

  <mat-tab-group mat-stretch-tabs>
    <mat-tab label="Adresse">
      <pr-input label="Situation" [derrors]="derrors" formGroupName="situation">
        <mat-select
          formControlName="situation"
          (ngModelChange)="onSituationButtonClick()"
        >
          @for (situation of situations; track situation) {
            <mat-option [value]="situation">
              {{ 'pages.realEstate.' + situation.toLowerCase() | translate }}
            </mat-option>
          }
        </mat-select>
      </pr-input>
      <pr-input-map
        label="Adresse principale"
        formGroupName="address"
        [isGMaps]="false"
        [countries]="countries"
        [derrors]="derrors"
      >
      </pr-input-map>
    </mat-tab>

    <mat-tab label="Régime mat." formGroupName="matrimonialRegime">
      <pr-input label="Situation maritale" [derrors]="derrors">
        <mat-select
          formControlName="maritalSituation"
          (ngModelChange)="updateMaritalStatus()"
        >
          @for (status of maritalStatus; track status) {
            <mat-option [value]="status.id">
              {{ status.value | translate }}
            </mat-option>
          }
        </mat-select>
      </pr-input>

      <pr-input
        label="Régime matrimonial"
        [derrors]="derrors"
        [hidden]="
          ['SINGLE', 'WIDOWER', 'DIVORCED', 'LIVETOGETHER'].includes(
            form.get('matrimonialRegime.maritalSituation').value
          )
        "
      >
        <mat-select formControlName="regime">
          @for (regime of selectedMarriageRegime; track regime) {
            <mat-option [value]="regime.id">
              {{ regime.value | translate }}
            </mat-option>
          }
        </mat-select>
      </pr-input>

      <pr-input
        label="Lieu du mariage"
        [derrors]="derrors"
        [hidden]="
          !['MARRIED'].includes(
            form.get('matrimonialRegime.maritalSituation').value
          )
        "
      >
        <input formControlName="location" />
      </pr-input>

      <pr-input-radio
        [hidden]="
          !['SINGLE', 'WIDOWER', 'DIVORCED'].includes(
            form.get('matrimonialRegime.maritalSituation').value
          )
        "
        formControlName="raiseChild5"
        label="Vous avez élevé seul un enfant pendant au moins 5 ans"
      >
      </pr-input-radio>
    </mat-tab>

    <mat-tab label="Fiscalité" formGroupName="fiscality">
      <pr-input [label]="'Parts fiscales'" [derrors]="derrors" suffix="part(s)"
        ><input formControlName="taxShare" type="number"
      /></pr-input>
    </mat-tab>
  </mat-tab-group>
</pr-form>

<pr-modal-confirm
  display="danger"
  icon="sp-warning"
  title="Suppression du conjoint"
  labelConfirm="Confirmer"
  labelCancel="Annuler"
  (onConfirm)="confirmSpousePurge()"
>
  <p>Le patrimoine de votre conjoint(e) sera définitivement supprimé.</p>
</pr-modal-confirm>
